<template>
  <div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      required: true,
      type: String
    }
  },
  methods: {
    popToast () {
      // Use a shorter name for this.$createElement
      const h = this.$createElement
      // Increment the toast count
      // Create the message
      const vNodesMsg = h(
        'p',
        { class: ['text-center', 'mb-0'] },
        [
          h('b-spinner', { props: { type: 'grow', small: true } }),
          ' Flashy ',
          h('strong', {}, 'toast'),
          ` message #${this.message} `,
          h('b-spinner', { props: { type: 'grow', small: true } })
        ]
      )
      // Create the title
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [
          h('strong', { class: 'mr-2' }, 'Tips'),
          h('small', { class: 'ml-auto text-italics' }, 'just now')
        ]
      )
      // Pass the VNodes as an array for message and title
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: 'info'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MessageBox.vue